import { render, staticRenderFns } from "./SaleBrandsSelected.vue?vue&type=template&id=08e70fcf&scoped=true&"
import script from "./SaleBrandsSelected.vue?vue&type=script&lang=js&"
export * from "./SaleBrandsSelected.vue?vue&type=script&lang=js&"
import style0 from "./SaleBrandsSelected.vue?vue&type=style&index=0&id=08e70fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e70fcf",
  null
  
)

export default component.exports